import React, { ComponentProps, forwardRef } from 'react';
import { inputBaseClasses, outlinedInputClasses, TextField as TextFieldMUI } from '@mui/material';

import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

import { ShapeProp } from '@/mui/types';

type Props = {
  shape?: ShapeProp;
  textAlign?: 'left' | 'center' | 'right';
  filled?: boolean;
} & ComponentProps<typeof TextFieldMUI>;

const TextField = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { shape, textAlign, sx, filled = props.variant === 'filled', ...rest } = props;

  return (
    <TextFieldMUI
      ref={ref}
      {...rest}
      variant="outlined"
      sx={{
        ...(textAlign && {
          [`& .${inputBaseClasses.input}`]: {
            textAlign,
          },
        }),
        ...(shape === SHAPE_SQUARE && {
          [`& .${inputBaseClasses.root}`]: {
            borderRadius: 0,
            '&:before': {
              left: 0,
              right: 0,
            },
            '&:after': {
              left: 0,
              right: 0,
            },
          },
        }),
        ...(shape === SHAPE_CIRCULAR && {
          [`& .${inputBaseClasses.root}`]: {
            borderRadius: (theme) => theme.shape.borderRadiusCircular,
            '&:before': {
              left: 16,
              right: 16,
            },
            '&:after': {
              left: 16,
              right: 16,
            },
          },
        }),
        ...(filled && {
          [`& .${outlinedInputClasses.root}`]: {
            backgroundColor: (theme) => theme.palette.shades[200],
          },
          [`& .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: 'transparent',
          },
        }),
        ...sx,
      }}
    />
  );
});

TextField.displayName = 'TextField';

export default TextField;
